import { createSelector } from '@reduxjs/toolkit';

import { AnalysisResult, AnalysisSet } from '@paragon/contract-library';

import { RootState } from '..';
import { getActiveAnalysisSet } from './getActiveAnalysisSetSelector';

export const getAnalysisResultGuids = (analysisSet: AnalysisSet) =>
  analysisSet.analysisResultGuidsByLoadCase
    ? Object.values(analysisSet.analysisResultGuidsByLoadCase)
    : analysisSet.analysisResultGuids;

export const getAnalysisResultRequestsForActiveAnalysisSet = createSelector(
  getActiveAnalysisSet,
  (state: RootState) => state.analysisResultRequests,
  (analysisSet, analysisResultRequests) =>
    (analysisSet &&
      getAnalysisResultGuids(analysisSet)?.map(
        (analysisResultGuid) => analysisResultRequests[analysisResultGuid] ?? null,
      )) ??
    null,
);

export const getAnalysisResultsForActiveAnalysisSet = createSelector(
  getAnalysisResultRequestsForActiveAnalysisSet,
  (analysisResultRequests): readonly AnalysisResult[] =>
    (analysisResultRequests ?? [])
      .map((analysisResultRequest) => (analysisResultRequest?.status === 'loaded' ? analysisResultRequest.item : null))
      .filter((analysisResult) => analysisResult) as readonly AnalysisResult[],
);
